import { d as zo } from "../diadia-CAnfNuqc.js";
import { F as Qo } from "../styled-components.browser.esm-CdvvWRMU.js";
const n = "#400000", o = "#9f0f00", i = "#ec3a0e", t = "#ff8679", a = "#fff2f2", c = "#001840", e = "#003d9f", s = "#0064d1", l = "#79acff", r = "#f2f7ff", p = "#202020", g = "#6c6c6c", S = "#dedede", D = "#f7f7f7", m = "#fcfcfc", x = "#003421", d = "#006e4a", h = "#0e9069", u = "#79d6b7", k = "#f2fdf9", R = "#402200", f = "#9f5200", I = "#d97d08", X = "#ffbe79", L = "#fff9f2", M = "#400016", b = "#9f003c", N = "#e20867", C = "#ff79ac", F = "#fff2f7", y = 0, B = "4px", H = "8px", v = "16px", W = "500px", P = "1000px", w = 0, z = "1px", q = "2px", Q = "4px", T = "576px", A = "1200px", O = 0.72, U = 0.32, G = 0.16, j = 0.08, E = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px -8px 16px -4px rgba(136, 128, 128, 0.16)", J = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px -16px 32px -8px rgba(136, 128, 128, 0.16)", K = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px -32px 64px -16px rgba(136, 128, 128, 0.16)", V = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px 8px 16px -4px rgba(136, 128, 128, 0.16)", Y = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px 16px 32px -8px rgba(136, 128, 128, 0.16)", Z = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px 32px 64px -16px rgba(136, 128, 128, 0.16)", _ = "4px", $ = "8px", nn = "12px", on = "16px", tn = "24px", an = "32px", cn = "40px", en = "48px", sn = "56px", ln = "80px", rn = "0.25rem", pn = "0.5rem", gn = "0.75rem", Sn = "1rem", Dn = "1.5rem", mn = "2rem", xn = "2.5rem", dn = "3rem", hn = "3.5rem", un = "5rem", kn = "4px", Rn = "8px", fn = "16px", In = "24px", Xn = "32px", Ln = "48px", Mn = "0.25rem", bn = "0.5rem", Nn = "1rem", Cn = "1.5rem", Fn = "2rem", yn = "3rem", Bn = "4px 8px", Hn = "8px 16px", vn = "16px 24px", Wn = "16px 32px", Pn = "0.25rem 0.5rem", wn = "0.5rem 1rem", zn = "1rem 1.5rem", qn = "1rem 2rem", Qn = "4px", Tn = "8px", An = "12px", On = "16px", Un = "24px", Gn = "32px", jn = "40px", En = "48px", Jn = "56px", Kn = "72px", Vn = "96px", Yn = "120px", Zn = "160px", _n = "0.25rem", $n = "0.5rem", no = "0.75rem", oo = "1rem", io = "1.5rem", to = "2rem", ao = "2.5rem", co = "3rem", eo = "3.5rem", so = "4.5rem", lo = "6rem", ro = "7.5rem", po = "10rem", go = "'AlicorpSans-Light', Helvetica, Arial, sans-serif", So = "'AlicorpSans-Regular', Helvetica, Arial, sans-serif", Do = "'AlicorpSans-Bold', Helvetica, Arial, sans-serif", mo = "'AlicorpSans-Semibold', Helvetica, Arial, sans-serif", xo = "SFMono-Regular, Menlo, Monaco, Consolas,  'Liberation Mono', 'Courier New', monospace", ho = "80px", uo = "64px", ko = "48px", Ro = "40px", fo = "32px", Io = "24px", Xo = "20px", Lo = "16px", Mo = "14px", bo = "12px", No = 300, Co = 400, Fo = 600, yo = 700, Bo = "1", Ho = "1.28", vo = "1.52", Wo = {
  darkMode: !1,
  brandPrimaryDarkest: n,
  brandPrimaryDark: o,
  brandPrimaryMedium: i,
  brandPrimaryLight: t,
  brandPrimaryLightest: a,
  brandHighlightDarkest: c,
  brandHighlightDark: e,
  brandHighlightMedium: s,
  brandHighlightLight: l,
  brandHighlightLightest: r,
  colorNeutralDarkest: p,
  colorNeutralDark: g,
  colorNeutralMedium: S,
  colorNeutralLight: D,
  colorNeutralLightest: m,
  colorNeutralSnow: "#ffffff",
  colorDisabledLight: "#faf8f7",
  colorDisabledMedium: "#d9d5d4",
  colorDisabledDark: "#7a706d",
  colorSupportTextDarkest: "#2e1b15",
  colorSupportPositiveDarkest: x,
  colorSupportPositiveDark: d,
  colorSupportPositiveMedium: h,
  colorSupportPositiveLight: u,
  colorSupportPositiveLightest: k,
  colorSupportWarningDarkest: R,
  colorSupportWarningDark: f,
  colorSupportWarningMedium: I,
  colorSupportWarningLight: X,
  colorSupportWarningLightest: L,
  colorSupportNegativeDarkest: M,
  colorSupportNegativeDark: b,
  colorSupportNegativeMedium: N,
  colorSupportNegativeLight: C,
  colorSupportNegativeLightest: F,
  borderRadiusSharp: y,
  borderRadiusSm: B,
  borderRadiusMd: H,
  borderRadiusLg: v,
  borderRadiusPill: W,
  borderRadiusCircular: P,
  borderWidthNone: w,
  borderWidthHairline: z,
  borderWidthThick: q,
  borderWidthHeavy: Q,
  gridBreakpointMobile: T,
  gridBreakpointDesktop: A,
  opacitySemiOpaque: O,
  opacityIntense: U,
  opacityLight: G,
  opacitySemiTransparent: j,
  shadowUp01: E,
  shadowUp02: J,
  shadowUp03: K,
  shadowDown01: V,
  shadowDown02: Y,
  shadowDown03: Z,
  spacingInlineQuarck: _,
  spacingInlineNano: $,
  spacingInlineMicro: nn,
  spacingInlineXxxs: on,
  spacingInlineXxs: tn,
  spacingInlineXs: an,
  spacingInlineSm: cn,
  spacingInlineMd: en,
  spacingInlineLg: sn,
  spacingInlineXl: ln,
  spacingInlineQuarckRem: rn,
  spacingInlineNanoRem: pn,
  spacingInlineMicroRem: gn,
  spacingInlineXxxsRem: Sn,
  spacingInlineXxsRem: Dn,
  spacingInlineXsRem: mn,
  spacingInlineSmRem: xn,
  spacingInlineMdRem: dn,
  spacingInlineLgRem: hn,
  spacingInlineXlRem: un,
  spacingInsetNano: kn,
  spacingInsetXs: Rn,
  spacingInsetSm: fn,
  spacingInsetMd: In,
  spacingInsetLg: Xn,
  spacingInsetXl: Ln,
  spacingInsetNanoRem: Mn,
  spacingInsetXsRem: bn,
  spacingInsetSmRem: Nn,
  spacingInsetMdRem: Cn,
  spacingInsetLgRem: Fn,
  spacingInsetXlRem: yn,
  spacingSquishNano: Bn,
  spacingSquishXs: Hn,
  spacingSquishSm: vn,
  spacingSquishMd: Wn,
  spacingSquishNanoRem: Pn,
  spacingSquishXsRem: wn,
  spacingSquishSmRem: zn,
  spacingSquishMdRem: qn,
  spacingStackQuarck: Qn,
  spacingStackNano: Tn,
  spacingStackMicro: An,
  spacingStackXxxs: On,
  spacingStackXxs: Un,
  spacingStackXs: Gn,
  spacingStackSm: jn,
  spacingStackMd: En,
  spacingStackLg: Jn,
  spacingStackXl: Kn,
  spacingStackXxl: Vn,
  spacingStackXxxl: Yn,
  spacingStackHuge: Zn,
  spacingStackQuarckRem: _n,
  spacingStackNanoRem: $n,
  spacingStackMicroRem: no,
  spacingStackXxxsRem: oo,
  spacingStackXxsRem: io,
  spacingStackXsRem: to,
  spacingStackSmRem: ao,
  spacingStackMdRem: co,
  spacingStackLgRem: eo,
  spacingStackXlRem: so,
  spacingStackXxlRem: lo,
  spacingStackXxxlRem: ro,
  spacingStackHugeRem: po,
  fontFamilyLight: go,
  fontFamilyRegular: So,
  fontFamilyBold: Do,
  fontFamilySemibold: mo,
  fontFamilyMonospace: xo,
  fontSizeXxl: ho,
  fontSizeXl: uo,
  fontSizeLg: ko,
  fontSizeMd: Ro,
  fontSizeSm: fo,
  fontSizeXs: Io,
  fontSizeXxs: Xo,
  fontSizeXxxs: Lo,
  fontSizeNano: Mo,
  fontSizeQuarck: bo,
  fontWeightLight: No,
  fontWeightRegular: Co,
  fontWeightSemibold: Fo,
  fontWeightBold: yo,
  lineHeightTight: Bo,
  lineHeightFair: Ho,
  lineHeightConfy: vo
};
export {
  Qo as ThemeProvider,
  zo as diadiaTheme,
  Wo as insumaTheme
};
